<template>
  <div class="card-container">
    <card class="card-login card-white">
      <Header pageTitle="Welcome to AGATRS!"></Header>
      <hr />
      <div class="text-left black">
        AGATRS is a worldwide, automated solution, supporting the Joint Staff J4, Global Combatant Commands (GCCs) and the Office of the Secretary of Defense (OSD), to manage, document, and track Acquisition Cross Servicing Agreements (ACSAs), Implementing Arrangements (IAs) and the subsequent ACSA orders for Logistics Support, Supplies, and Services (LSSS) that are executed under these agreements.
        <br />
        <br />AGATRS is the system of record for all DoD agencies to record ACSA transactions. AGATRS is used to supplement information required by financial personnel and senior leadership, and its use is mandatory.
        <br />
        <br />AGATRS Capabilities:
        <ul>
          <li>Tracking of Acquisition Cross Servicing Agreements, Implementing Arrangements, and subsequent ACSA orders for LSSS executed under the agreements</li>
          <li>Key Logistics/Financial data fields allows cross referencing to other supply/financial systems</li>
          <li>Digital signature enabled documentation containing all essential data elements</li>
          <li>Supporting documentation upload features enabling proper accountability for transaction authorization, receiving confirmation, and financial execution documents</li>
          <li>Advanced, customizable reporting capabilities</li>
        </ul>To request training materials, or contact the AGATRS team with any questions, please utilize the Helpdesk and Feedback button on the bottom of the page.
      </div>
    </card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Header from "@/components/App/Header";
export default {
  name: "Home",
  components: {
    Header,
  },
  data: function () {
    return {};
  },
  computed: {
    // ...authComputed
    ...mapGetters({
      isLoggedIn: "authentication/isLoggedIn",
    }),
  },
  mounted: function () {},
  updated: function () {},
  destroyed: function () {},
  methods: {},
};
</script>

<style>
/* This changes <li> element's text color to black */
.white-content h1,
.white-content h2,
.white-content h3,
.white-content h4,
.white-content h5,
.white-content h6,
.white-content p,
.white-content ol li,
.white-content ul li,
.white-content pre {
  color: black;
}
</style>
